import { MediaAxios } from '../axios/media/media.axios';

export function getMediaUrl(mediaId: string) {
  return MediaAxios.getImageUrl(mediaId);
}
